<template>
    <div>
        <div :style="draggedStyle" class="cic-popup">
            <ul class="cic-container">
                <li
                    :class="{ draggable }"
                    class="cic-header"
                    @mousedown="startDrag"
                    @mouseup="stopDrag"
                    @mouseout="stopDrag"
                    @mousemove="drag"
                >
                    <span class="cic-header-title">{{ title !== '' ? $t(title) : '&nbsp;' }}</span>
                    <IconButton v-if="helpText" icon="help-icon" :title="helpText" />
                    <span v-if="editable" id="btnEdit" class="cic-header-edit" @click="$emit('edit')"></span>
                </li>
                <li class="cic-popup-body">
                    <slot></slot>
                </li>
                <li class="cic-footer">
                    <cic-button id="popup_cancel" @click="closePopup">
                        {{ $t('Cancel') }}
                    </cic-button>
                    <cic-button v-if="exportable" id="popup_export" @click="$emit('export')">
                        {{ $t('Export') }}
                    </cic-button>
                    <cic-button v-if="saveable" id="popup_save" @click="saveItem">
                        {{ $t(saveButtonLabel) }}
                    </cic-button>
                    <slot name="footer"></slot>
                </li>
            </ul>
        </div>
        <div class="cic-overlay" @click="closePopup"></div>
    </div>
</template>

<script>
    import CicButton from '@/components/CicButton';
    import IconButton from '@/components/controls/IconButton';

    export default {
        name: 'CicPopup',
        components: { CicButton, IconButton },
        props: {
            draggable: {
                type: Boolean,
                default: true,
            },
            editable: {
                type: Boolean,
                default: false,
            },
            exportable: {
                type: Boolean,
                default: false,
            },
            helpText: {
                type: String,
                default: undefined,
            },
            saveable: {
                type: Boolean,
                default: false,
            },
            saveButtonLabel: {
                type: String,
                default: 'Save',
            },
            title: {
                type: String,
                default: '',
            },
        },
        emits: ['blur', 'edit', 'export', 'input'],
        data() {
            return {
                dragging: false,
                draggingOrigin: [0, 0],
                draggedStyle: {},
            };
        },
        methods: {
            closePopup() {
                this.$emit('blur');
            },

            drag(evt) {
                if (this.dragging && evt.pageY > 0 && evt.pageX > 0) {
                    this.draggedStyle = {
                        position: 'absolute',
                        marginLeft: 0,
                        left: evt.pageX - this.draggingOrigin[0] + 'px',
                        top: evt.pageY - this.draggingOrigin[1] + 'px',
                    };
                }
            },

            saveItem() {
                this.$emit('input');
            },

            startDrag(evt) {
                if (this.draggable) {
                    this.dragging = true;
                    let panel = evt.target.parentElement.parentElement;

                    let offsetX = evt.pageX - window.scrollX - panel.getBoundingClientRect().left;
                    let offsetY = evt.pageY - window.scrollY - panel.getBoundingClientRect().top;

                    this.draggingOrigin = [offsetX, offsetY];
                }
            },

            stopDrag() {
                this.dragging = false;
            },
        },
    };
</script>
